import { create } from "zustand"

export const layoutModeTypes = {
  DARK: "dark",
  LIGHT: "light",
}

const localTheme = localStorage.getItem("theme")

const initialTheme = localStorage.getItem("theme") || layoutModeTypes.LIGHT

export const useLayoutStore = create(set => ({
  layoutModeType: initialTheme,
  setLayoutModeType: type =>
    set(state => {
      try {
        localStorage.setItem("theme", type)
        if (document.body) {
          document.body.setAttribute("data-layout-mode", type)
          document.body.setAttribute("data-sidebar", type)
        }
      } catch (error) {
        console.log(error)
      }
      return {
        ...state,
        layoutModeType: type,
      }
    }),
}))
